<template>


    <mt-tabbar v-model="selected" fixed >
      <!--<mt-tab-item v-for="(title,index) in tabbarTitles" id="title">-->
        <!--<img slot="icon" src='../../../assets/tabbar_home.png'>{{title}}-->
      <!--</mt-tab-item>-->

      <mt-tab-item  id="首页" class="tab-item" @click.native="changePage('/home','首页')">
        <img slot="icon" v-if="selected === '首页'" src="../../assets/icon/tabbar_home_selected.png" class="tab-item-img">
        <img slot="icon" v-else  src="../../assets/icon/tabbar_home.png" class="tab-item-img">
        <div class="tab-item-title">首页</div>
      </mt-tab-item>

      <!--<mt-tab-item  id="团购预约" class="tab-item">-->
        <!--<div class="tab-item-imgdiv">-->
        <!--<img slot="icon" v-if="selected === '团购预约'" src="../../../assets/tabbar_home_selected.png" class="tab-item-img">-->
        <!--<img slot="icon" v-else  src="../../../assets/tabbar_home.png" class="tab-item-img">-->
        <!--</div>-->
        <!--<div class="tab-item-title">团购预约</div>-->
      <!--</mt-tab-item>-->

      <mt-tab-item  id="购物车" class="tab-item" @click.native="changePage('/ShoppingCart','购物车')">
        <img slot="icon" v-if="selected === '购物车'" src="../../assets/icon/TabBar_Cart_selected.png" class="tab-item-img">
        <img slot="icon" v-else  src="../../assets/icon/TabBar_Cart.png" class="tab-item-img">
        <div class="tab-item-title">购物车</div>
      </mt-tab-item>

      <mt-tab-item  id="我的" class="tab-item" @click.native="changePage('/Mine','我的')">
        <img slot="icon" v-if="selected === '我的'" src="../../assets/icon/TabBar_My_selected.png" class="tab-item-img">
        <img slot="icon" v-else  src="../../assets/icon/TabBar_My.png" class="tab-item-img">
        <div class="tab-item-title">我的</div>
      </mt-tab-item>

    </mt-tabbar>

</template>

<script>

  export default {
    name: 'root',
    data () {
      return {
        selected: '首页'
      }
    },
    watch: {
      // 监听selected变量，当用户点击不同item的时候，将页面跳转至相应界面
//      selected (newVal, oldVal) {
//        if (newVal === '首页') {
//          this.$router.replace({path: '/home'})
//        } else if (newVal === '购物车') {
//          this.$router.replace({path: '/ShoppingCart'})
//        } else if (newVal === '我的') {
//          this.$router.replace({path: '/Mine'})
//        } else {
//          this.$router.replace({path: '/home'})
//        }
//      }
    },
    destroyed () {
    },
    created () {
//      this.utils.alert(this.utils.isWXUA())
    },
    updated () {
      this.setTabbarItem()
    },
    mounted () {

      this.setTabbarItem()

      var self = this
      this.$router.beforeEach(function (to,from,next) {

        let path = to.path.toLocaleLowerCase()
        var name = ''
        if (path === '/home') {
          name = '首页'
        } else if (path === '/shoppingcart') {
          name = '购物车'
        } else if (path === '/mine') {
          name = '我的'
        } else if (path === '/') {
          name = '首页'
        } else {
          name = '首页'
        }
        if (name !== self.selected) {
          self.selected = name
        }
        next();
      })
    },
    methods: {
      changePage (path,name) {
        this.$router.replace({path: path})
        this.selected = name
      },
      setTabbarItem () {
        // 当通过/shoppingcart,/home,/mine进入的时候，将tabbar选择正确的item
        var path = this.$route.fullPath.toLocaleLowerCase()
        var name = ''
        if (path === '/home') {
          name = '首页'
        } else if (path === '/shoppingcart') {
          name = '购物车'
        } else if (path === '/mine') {
          name = '我的'
        } else if (path === '/') {
          name = '首页'
        } else {
          name = '首页'
        }
        if (name !== this.selected) {
          this.selected = name
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/css/mixin';

  .mint-tabbar > .mint-tab-item.is-selected {
    background-color: rgba(255,0,0,0);
    color: #191919;
  }
  .mint-tabbar > .mint-tab-item {
    background-color: rgba(255,0,0,0);
    color: rgba(25,25,25,0.5);
  }
  .mint-tabbar {
    height: pxToRem(110px);
  }
  #root {

  }

</style>



// WEBPACK FOOTER //
// mainNavBar.vue?c46961c2